<template>
  <div class="section-statistics__tab">
    <div
      v-show="isShow('opens-table')"
      :class="[
        'section-statistics__row',
        {'section-statistics__row--long-table-mode': longTablePart && longTablePart === 'opens-table'}
      ]"
    >
      <BarPart
        :isLoading="isLoading"
        :isError="isError"
        :value="formData(value)"
      />

      <TablePart />
    </div>

    <HourlyBarPart
      v-show="isShow('opens-hourly-table')"
      :isLoading="isLoading"
      :isError="isError"
      :value="formData(valueByHour)"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getPercent } from "@/utils/general";
import tabs_mixin from "@/components/statistics/stats/tabs/tabs_mixin";

import TablePart from "./TablePart.vue";
import BarPart from "./BarPart.vue";
import HourlyBarPart from "./HourlyBarPart.vue";

export default {
  components: {
    TablePart,
    BarPart,
    HourlyBarPart,
  },
  mixins: [tabs_mixin],

  data() {
    return {
      hourlyData: [],
    };
  },

  computed: {
    ...mapState({
      isLoading: state => state.stat.loadings.details,
      isError: state => state.stat.errors.details,
    }),
    value() {
      return this.$store.getters.getDetails;
    },
    valueByHour() {
      return this.$store.getters.getDetailsByHour;
    },
  },

  methods: {
    getHourlyData(val) {
      this.hourlyData = val;
    },
    formData(arr) {
      return arr.map(i => {
        const { date, delivered, opened, openedTotal } = i;

        return {
          date,
          delivered,
          openedTotal,
          openedTotalPercent: getPercent(delivered, openedTotal),
          opened,
          openedPercent: getPercent(delivered, opened),
        };
      });
    },
  },
};
</script>
